/**
 * Telling the tablet the guest is finished.
 *
 * On the handheld's "Pay here" path this app runs inside an Android WebView on the tablet, and the guest
 * works through the whole flow there - pay, then feedback, then the receipt they may want texted to
 * themselves. The tablet deliberately does NOT advance on the payment event, because that would tear the
 * WebView away mid-sentence. It waits for this instead.
 *
 * A navigation to a scheme the WebView intercepts and never loads. Their choice, and the lowest-friction one
 * to catch on Android; a `postMessage` would need a JS bridge injected on their side and a handshake on
 * this one. See docs/request-tablet-completion-signal.md.
 *
 * ONE-WAY AND UNACKNOWLEDGED. Nothing here can tell whether the tablet heard it: on the phone path this is
 * never called, and in a browser with no handler for the scheme the navigation simply does nothing. That is
 * why it is not a substitute for the tablet's own status poll, which is where the payment result actually
 * comes from.
 */
export const TABLET_COMPLETE_URL = 'touchtab://guestpay/complete';

/**
 * @param target injectable so a test can watch the navigation rather than perform one - jsdom refuses an
 * unknown scheme and logs a "Not implemented: navigation" error either way.
 */
export function signalTabletCompletion(target: Window = window): void {
    try {
        target.location.assign(TABLET_COMPLETE_URL);
    } catch {
        // A browser that will not navigate to an unknown scheme throws rather than ignoring it. There is
        // nothing to fall back to and nothing the guest could do about it - the tablet still has its own
        // manual way back to the QR screen, and on any other device this was never going to be called.
    }
}
